<template>
  <div class="home">
    <!-- 项目卡片网格 - 使用响应式布局 -->
    <n-grid :x-gap="20" :y-gap="20" :cols="responsiveCols">
      <!-- EasyApis 项目卡片 -->
      <n-grid-item>
        <n-card 
          hoverable 
          class="project-card"
          @click="navigateToProject('easyapis')"
        >
          <div class="card-content">
            <div class="card-icon" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
              <n-icon size="48" color="white">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10s10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5l1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
                </svg>
              </n-icon>
            </div>
            
            <n-h3 style="margin: 16px 0 8px 0;">EasyApis</n-h3>
            <n-text depth="3" style="font-size: 14px; line-height: 1.6;">
              简单易用的 API 工具集合，提供各种实用的接口服务
            </n-text>
            
            <n-divider style="margin: 16px 0;" />
            
            <n-space>
              <n-tag type="success" size="small">已启用</n-tag>
              <n-tag type="info" size="small">v1.0.0</n-tag>
            </n-space>
          </div>
        </n-card>
      </n-grid-item>
      
      <!-- 文本处理项目卡片 -->
      <n-grid-item>
        <n-card
          hoverable
          class="project-card"
          @click="navigateToProject('textprocess')"
        >
          <div class="card-content">
            <div class="card-icon" style="background: linear-gradient(135deg, #f0a020 0%, #d97706 100%);">
              <n-icon size="48" color="white">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M11 6h2v3h6v2H5V9h6V6zm-6 7h14v2H5v-2zm0 4h9v2H5v-2z"/>
                </svg>
              </n-icon>
            </div>

            <n-h3 style="margin: 16px 0 8px 0;">文本处理</n-h3>
            <n-text depth="3" style="font-size: 14px; line-height: 1.6;">
              按自定义规则批量加工文本，规则可保存复用
            </n-text>

            <n-divider style="margin: 16px 0;" />

            <n-space>
              <n-tag type="success" size="small">已启用</n-tag>
              <n-tag type="info" size="small">v1.0.0</n-tag>
            </n-space>
          </div>
        </n-card>
      </n-grid-item>

      <!-- 未来项目占位卡片 2 -->
      <n-grid-item>
        <n-card hoverable class="project-card placeholder-card">
          <div class="card-content">
            <div class="card-icon" style="background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);">
              <n-icon size="48" color="white">
                <svg viewBox="0 0 24 24">
                  <path fill="currentColor" d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"/>
                </svg>
              </n-icon>
            </div>
            
            <n-h3 style="margin: 16px 0 8px 0;">未来项目</n-h3>
            <n-text depth="3" style="font-size: 14px; line-height: 1.6;">
              更多精彩内容敬请期待...
            </n-text>
            
            <n-divider style="margin: 16px 0;" />
            
            <n-tag type="warning" size="small">即将推出</n-tag>
          </div>
        </n-card>
      </n-grid-item>
    </n-grid>
    
    <!-- 底部统计信息 -->
    <n-card style="margin-top: 40px;">
      <n-space justify="space-around">
        <n-statistic label="总项目数" value="2" />
        <n-statistic label="已启用" value="2" />
        <n-statistic label="开发中" value="1" />
      </n-space>
    </n-card>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue';
import { useRouter } from 'vue-router';
import { useMessage } from 'naive-ui';

export default defineComponent({
  name: 'HomeView',
  setup() {
    const router = useRouter();
    const message = useMessage();
    
    // 响应式网格列数（根据屏幕尺寸自适应）
    const responsiveCols = computed(() => {
      return '1 600:2 900:3 1200:4 1600:5';
    });
    
    // 导航到子项目
    const navigateToProject = (projectName: string) => {
      if (projectName === 'easyapis') {
        router.push('/easyapis');
      } else if (projectName === 'textprocess') {
        router.push('/textprocess');
      } else {
        message.warning('该项目即将推出，敬请期待！');
      }
    };
    
    return {
      responsiveCols,
      navigateToProject
    };
  }
});
</script>

<style scoped>
/* 首页容器 */
.home {
  max-width: 1600px;
  margin: 0 auto;
  padding: 40px 20px;
}

/* 头部区域 */
.header-section {
  text-align: center;
  margin-bottom: 20px;
}

/* 项目卡片样式 */
.project-card {
  cursor: pointer;
  transition: all 0.3s ease;
  height: 100%;
  min-height: 280px;
}

.project-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.15);
}

/* 卡片内容布局 */
.card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 20px;
}

/* 卡片图标样式 */
.card-icon {
  width: 100px;
  height: 100px;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
}

/* 占位卡片样式（未来项目） */
.placeholder-card {
  opacity: 0.7;
}

.placeholder-card:hover {
  opacity: 0.9;
}
</style>

